import {REST_GLIDER_URL} from "../common/constants";
import ExpandableList from "../common/ExpandableList";
import {GliderForm} from "./Glider";
import GliderDocument from "./GliderDocument";

/** Stejně jako u pilotů: neaktivní (`active === false`) až za aktivními, uvnitř skupiny podle názvu. */
export const sortGlider = (a, b) => {
    const aInactive = a.active === false;
    const bInactive = b.active === false;
    if (aInactive === bInactive) {
        return (a.name || "").localeCompare(b.name || "", undefined, { numeric: true, sensitivity: "base" });
    }
    if (aInactive) {
        return 1;
    }
    return -1;
};

export const GliderList = ExpandableList(GliderDocument, GliderForm, REST_GLIDER_URL, "glider", "Seznam kluzáků", "Nový kluzák", "Přidat kluzák", sortGlider);

